if(!customElements.get('bt-shopping-accessibility'))customElements.define('bt-shopping-accessibility',class extends HTMLElement{
 connectedCallback(){
  this.cleanups=[];this.pickers=new WeakSet();this.menus=new WeakSet();this.drawers=new WeakSet();
  this.mount=documentRoot=>{
   if(!(documentRoot instanceof Element)&&documentRoot!==document)return;
   const pickers=[...(documentRoot.matches?.('variant-picker')?[documentRoot]:[]),...documentRoot.querySelectorAll('variant-picker')];
   pickers.forEach(picker=>this.setupPicker(picker));
   const menus=[...(documentRoot.matches?.('header dropdown-opener')?[documentRoot]:[]),...documentRoot.querySelectorAll('header dropdown-opener')];
   menus.forEach(menu=>this.setupMenu(menu));
   const drawers=[...(documentRoot.matches?.('#CartDrawer')?[documentRoot]:[]),...documentRoot.querySelectorAll('#CartDrawer')];drawers.forEach(drawer=>this.setupDrawer(drawer));
  };
  this.mount(document);
  this.focusHandler=event=>{if(event.target.closest('label[role="radio"]')?.htmlFor!==this.focusedRadio)this.focusedRadio=null};
  document.addEventListener('focusin',this.focusHandler);
  this.escapeHandler=event=>{
   if(event.key!=='Escape')return;
   const menu=document.querySelector('header dropdown-opener[aria-expanded="true"]');if(!menu)return;
   event.preventDefault();event.stopImmediatePropagation();menu.querySelector('[data-float-element-trigger]')?.click();menu.focus();
  };
  document.addEventListener('keydown',this.escapeHandler,true);
  this.observer=new MutationObserver(records=>{
   records.forEach(record=>record.addedNodes.forEach(node=>this.mount(node)));
   if(this.focusedRadio&&(!document.activeElement||document.activeElement===document.body)){
    const input=document.getElementById(this.focusedRadio);
    const label=input?.labels?.[0];if(label?.getClientRects().length)label.focus({preventScroll:true});
   }
  });
  this.observer.observe(document.body,{childList:true,subtree:true});
 }
 disconnectedCallback(){this.observer?.disconnect();document.removeEventListener('keydown',this.escapeHandler,true);document.removeEventListener('focusin',this.focusHandler);this.cleanups.forEach(cleanup=>cleanup())}
 setupPicker(picker){
  if(this.pickers.has(picker))return;this.pickers.add(picker);
  const selector='.product-variant-picker__pill-list label[for],.bt-color-cards label[for],.bt-club-picker label[for]';
  const sync=()=>{
   picker.querySelectorAll('[data-variant-picker-option-labels]').forEach(group=>{
    const labels=[...group.querySelectorAll(selector)].filter(label=>label.control?.type==='radio');
    if(!labels.length)return;
    group.setAttribute('role','radiogroup');group.setAttribute('aria-label',group.getAttribute('option-picker-name'));
    labels.forEach(label=>{
     const input=label.control;
     label.setAttribute('role','radio');label.setAttribute('aria-checked',String(input.checked));label.tabIndex=input.checked?0:-1;
     label.setAttribute('aria-label',input.value+(label.hasAttribute('no-available')?' — '+this.dataset.unavailable:''));
    });
   });
  };
  const keydown=event=>{
   const label=event.target.closest(selector);
   if(!label||!picker.contains(label))return;
   if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End',' ','Enter'].includes(event.key))return;
   event.preventDefault();event.stopImmediatePropagation();
   const labels=[...label.closest('[data-variant-picker-option-labels]').querySelectorAll(selector)].filter(item=>item.control?.type==='radio'&&item.getClientRects().length);
   const index=labels.indexOf(label);let next=index;
   if(event.key==='Home')next=0;
   else if(event.key==='End')next=labels.length-1;
   else if(['ArrowRight','ArrowDown'].includes(event.key))next=(index+1)%labels.length;
   else if(['ArrowLeft','ArrowUp'].includes(event.key))next=(index-1+labels.length)%labels.length;
   const target=labels[next];if(!target)return;
   this.focusedRadio=target.htmlFor;target.focus();if(!target.control.checked)target.control.click();sync();
  };
  picker.addEventListener('keydown',keydown,true);picker.addEventListener('change',sync);
  const observer=new MutationObserver(sync);observer.observe(picker,{childList:true,subtree:true,attributes:true,attributeFilter:['class','no-available']});sync();
  this.cleanups.push(()=>{observer.disconnect();picker.removeEventListener('keydown',keydown,true);picker.removeEventListener('change',sync)});
 }
 setupMenu(menu){
  if(this.menus.has(menu))return;this.menus.add(menu);
  const trigger=menu.querySelector('[data-float-element-trigger]');if(!trigger)return;
  menu.setAttribute('role','button');menu.tabIndex=0;menu.setAttribute('aria-label',trigger.getAttribute('menu-title')||trigger.textContent.trim());menu.setAttribute('aria-controls',menu.dataset.floatElementId);
  const sync=()=>menu.setAttribute('aria-expanded',menu.getAttribute('data-aria-expanded')==='true'?'true':'false');
  const keydown=event=>{
   if(event.key==='Enter'||event.key===' '){event.preventDefault();event.stopImmediatePropagation();trigger.click()}
   if(event.key==='Tab'&&!event.shiftKey&&menu.getAttribute('aria-expanded')==='true'){
    const panel=document.getElementById(menu.dataset.floatElementId);
    const first=[...panel.querySelectorAll('a[href],button,input,select,summary,[tabindex="0"]')].find(item=>item.getClientRects().length&&!item.disabled);
    if(first){event.preventDefault();event.stopImmediatePropagation();first.focus()}
   }
   if(event.key==='Escape'&&menu.getAttribute('aria-expanded')==='true'){event.preventDefault();event.stopImmediatePropagation();trigger.click();menu.focus()}
  };
  menu.addEventListener('keydown',keydown,true);
  const observer=new MutationObserver(sync);observer.observe(menu,{attributes:true,attributeFilter:['data-aria-expanded']});sync();
  this.cleanups.push(()=>{observer.disconnect();menu.removeEventListener('keydown',keydown,true)});
 }
 setupDrawer(drawer){
  if(this.drawers.has(drawer))return;this.drawers.add(drawer);
  customElements.whenDefined('cart-drawer').then(()=>{
   if(!drawer.isConnected)return;
   const nativeOpen=drawer.open;const nativeHide=drawer.hide;
   if(typeof nativeOpen!=='function'||typeof nativeHide!=='function')return;
   let closing=null;let intent=0;
   drawer.hide=function(...args){
    intent++;
    const result=nativeHide.apply(this,args);
    const pending=Promise.allSettled([closing,result]);closing=pending;
    pending.then(()=>{if(closing===pending)closing=null});return result;
   };
   drawer.open=function(...args){
    const request=++intent;
    if(!closing)return nativeOpen.apply(this,args);
    return closing.then(()=>{if(request===intent&&this.isConnected)return nativeOpen.apply(this,args)});
   };
   this.cleanups.push(()=>{intent++;drawer.open=nativeOpen;drawer.hide=nativeHide});
  });
  drawer.setAttribute('role','dialog');drawer.setAttribute('aria-label',this.dataset.cartLabel);
  let open=false;let opener=null;
  const targets=()=>[...drawer.querySelectorAll('a[href],button,input,select,textarea,summary,[tabindex="0"]')].filter(item=>item.getClientRects().length&&!item.disabled&&getComputedStyle(item).visibility!=='hidden');
  const focusFirst=()=>{const first=targets()[0]||drawer;first.focus({preventScroll:true})};
  const remember=event=>{if(!open&&!drawer.contains(event.target)){const target=event.target.closest('button,a,[role="button"]');if(target)opener=target}};
  const sync=()=>{
   const next=drawer.classList.contains('is-opened');if(next===open)return;open=next;
   drawer.toggleAttribute('aria-modal',open);if(open){drawer.setAttribute('aria-modal','true');focusFirst()}
   else if(opener?.isConnected)opener.focus({preventScroll:true});
  };
  const focusin=event=>{
   if(!open||drawer.contains(event.target))return;
   if(event.target.closest('dialog[open],[role="dialog"][aria-modal="true"]'))return;
   focusFirst();
  };
  const keydown=event=>{
   if(!open||event.key!=='Tab')return;
   const items=targets();if(!items.length){event.preventDefault();drawer.focus();return}
   if(event.shiftKey&&event.target===items[0]){event.preventDefault();items[items.length-1].focus()}
  };
  document.addEventListener('click',remember,true);document.addEventListener('focusin',focusin);document.addEventListener('keydown',keydown,true);
  const observer=new MutationObserver(sync);observer.observe(drawer,{attributes:true,attributeFilter:['class']});sync();
  this.cleanups.push(()=>{observer.disconnect();document.removeEventListener('click',remember,true);document.removeEventListener('focusin',focusin);document.removeEventListener('keydown',keydown,true)});
 }
});
